"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";
import { Input } from "rizzui";

export default function CorporateHeaderEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  const navItems = content.navItems || ["Solutions", "Enterprise", "About", "Contact"];

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Logo brand</h4>
            <Input
              value={content.logo || ""}
              onChange={(e) => updateContent("logo", e.target.value)}
              placeholder="CORP INC"
              className="!rounded-lg"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Navigation Items</h4>
            {navItems.map((item: string, idx: number) => (
              <Input
                key={idx}
                value={item}
                onChange={(e) => {
                  const current = [...navItems];
                  current[idx] = e.target.value;
                  updateContent("navItems", current);
                }}
                className="!rounded-md text-xs"
                placeholder="Solutions"
              />
            ))}
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Header Button</h4>
            <Input
              value={content.ctaText || "Client Login"}
              onChange={(e) => updateContent("ctaText", e.target.value)}
              placeholder="Client Login"
              className="!rounded-lg"
            />
            <Input
              value={content.ctaLink || ""}
              onChange={(e) => updateContent("ctaLink", e.target.value)}
              placeholder="#login"
              className="!rounded-lg"
            />
          </div>
        </div>
      }
    />
  );
}
